import { Box } from "@mui/material";
import { useForUserType } from "hooks";
import { PageHeaderTitle } from "pages/components/page-header-title";
import {
  WidgetCardCounts,
  WidgetCardCountsType,
} from "pages/components/widgets/widget-card-counts";
import { shallowEqual, useSelector } from "react-redux";
import { IRootState } from "redux/types";
import { UserType } from "service";
import { AssignmentsRegistryFilterBlock } from "../assignments-registry-filter-block";

export const AssignmentsRegistrySectionTop = () => {
  const { assignments } = useSelector(
    (state: IRootState) => state.assignments,
    shallowEqual
  );
  const { isIt } = useForUserType();

  return (
    <Box mb={"32px"}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <PageHeaderTitle
          title={
            isIt(UserType.Admin)
              ? "Панель задач"
              : isIt(UserType.Manager)
              ? "Мои задачи"
              : "Реестр задач"
          }
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "24px",
          my: "32px",
        }}
      >
        <WidgetCardCounts
          count={assignments.value?.info.total ?? 0}
          type={WidgetCardCountsType.total}
        />
        <WidgetCardCounts
          count={assignments.value?.info.completed ?? 0}
          type={WidgetCardCountsType.completed}
        />
      </Box>
      <AssignmentsRegistryFilterBlock />
    </Box>
  );
};
